<template>
    <div class="bg-white">
    
        <!-- <CCol sm="12" lg="8" class="mx-auto" style="width: 70%; background-size: cover; color: #fff;">
                <div>
                    <CRow>
                        <CCol sm="8" style="margin:0 auto">
                            <div style="margin-top: 15%;">
                                <CCard class="b-20">
                                    <h3 class="text-center text-black mt-5">Welcome Back</h3>
        
                                    <CCol sm="12" style="width: 70%; background-size: cover; margin: auto; color: #fff;">
                                        <CRow class="mt-5">
                                            <div v-if="this.Error == true" class="ml-1 mr-1 mt-2 mb-2">
                                                <CAlert show color="danger" class="custom-error-message">The credentials entered is incorrect.Please try again.</CAlert>
                                            </div>
                                            <CCol sm="12">
                                                <h3 class="custom-14px">Email Address</h3>
                                                <CInput type="text" class="custom-input b-50" v-model="Email" />
                                            </CCol>
                                            <CCol sm="12">
                                                <h3 class="custom-14px">Password</h3>
                                                <CInput type="password" class="custom-input b-50" v-model="Password" />
                                            </CCol>
                                            <CCol sm="12">
                                                <div class="text-right">
                                                    <label class="custom-16px-600">
                                                            I forgot my password
                                                        </label>
                                                </div>
                                            </CCol>
                                            <CButton type="button" class="bg-button-blue text-white m-2" block v-on:click="trylogin">Login</CButton>
                                        </CRow>
                                        <CRow>
                                            <img src="../assets/img/loginwith.png" style="max-width:100%" />
                                            <div style="width:50%">
                                                <div class="text-center bg-grey b-20 p-2 m-20" style="border:none;margin:10px" @click="login">
                                                    <img style="width:25px" src="../assets/img/google1.png" class="mt-1 mb-1 mr-2" />
                                                </div>
                                            </div>
                                            <div style="width:50%">
                                                <div class="text-center bg-grey b-20 p-2 m-20" style="border:none;margin:10px">
                                                    <img style="width:25px" src="../assets/img/apple1.png" class="mt-1 mb-1 ml-2" />
                                                </div>
                                            </div>
        
                                        </CRow>
                                        <div class="text-center mt-3">
                                            <label class="custom-14px poppin-font"> Don’t have an account? <a href="CreateAccount">Create Now</a></label>
                                        </div>
                                    </CCol>
        
                                    <div class="mt-4">
                                        <div class="inline-container">
        
                                            <span class="text-center text-black" style="margin-left:40%">{{ lblGoogle }}</span>
        
                                        </div>
                                    </div>
        
        
                                </CCard>
                                <br /><br />
                            </div>
                        </CCol>
                    </CRow>
                </div>
            </CCol> -->
    
        <div>
            <CRow class="g-3">
                <CCol sm="6" lg="6">
                    <div class="p-2">
                        <div style="background-position: center;background-size: cover; min-height: 100vh;border-radius:18px" :style="{ backgroundImage: `url(${backgroundUrl})` }"></div>
                    </div>
                </CCol>
    
                <CCol sm="6">
                    <CRow class="p-2">
                        <CCol sm="8"></CCol>
                        <CCol sm="4">
                            <img src="../assets/img/Logo.png" height="32" alt="Interviewrr.ai company logo" class="mt-2"/> <span class="custom-20px-500 text-white"></span>
                        </CCol>
    
                    </CRow>
    
                    <CContainer style="max-width: 600px; text-align: left;">
                        <div style="margin-top:20%">
                            <h3 class="custom-24px-600 font-color-171717 text-left">Login to your account</h3>
                            <p class="custom-18px-500"><span class="font-color-666D80">Enter your details to login</span></p>
                        </div>
    
                        <div v-if="ErrorLogin" class="">
                            <CAlert show color="danger">
                                <strong class="text-danger mr-2">Error!</strong> {{ Message }}
                            </CAlert>
                        </div>
                        <CRow>
                            <CCol sm="6">
                                <div class="custom-btn-white mt-4">
                            <div class="text-center">
                                <span class="custom-124px-600 font-color-171717 mr-2">Login as User</span>
                                <input type="radio" class="mt-2" v-model="selectedUser" value="user" @change="registerAccountGoogleUser"/>
                            </div>
                        </div>
                            </CCol>
                            <CCol sm="6">
                                <div class="custom-btn-white mt-4">
                            <div class="text-center">
                                <span class="custom-124px-600 font-color-171717 mr-2">Login as Admin</span>
                                <input type="radio" class="mt-2" v-model="selectedUser" value="admin" @change="registerAccountGoogleUser"/>
                            </div>
                        </div>
                            </CCol>
                        </CRow>
                        <CCol sm="12" class="text-center">
                            <p class="text-center custom-16px-500 font-color-171717 mt-3" v-if="showProgress">Processing</p>
                            <p class="text-center custom-16px-500 font-color-171717 mt-3">Don’t have an account?<label class="font-color-064BB4 ml-2" @click="GoToSignUp()">Sign Up</label></p>
                        </CCol>

                      
    
    
    
    
    
    
                    </CContainer>
                </CCol>
    
    
            </CRow>
    
        </div>
    
    
    </div>
</template>
<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgloginsport2.png";
import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";


import GAuth from 'vue-google-oauth2'

const gauthOption = {
    clientId: '435242184873-lfkbjg7vnqp31opg3qgnn1u0pf0ve5kt.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'consent',
    fetch_basic_profile: true,
    plugin_name: 'vue-google-oauth2',
}

Vue.use(GAuth, gauthOption)


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout
    },

    data() {
        return {
            backgroundUrl: backgroundUrl,
            Email: "",
            Password: "",
            Error: false,
            lblGoogle: "Sign up with Google",
            lblFb: "Sign up with Facebook",
            lblApple: "Sign up with Apple",
            selectedUser: null,
            showProgress: false

        };
    },
    created() {
        AOS.init();
    },
    methods: {
        GoToSignUp()
        {
            this.$router.push("CreateAccount");
        },
        registerAccountGoogleUser() {
            this.showProgress = true;
            const formData = new FormData();
    formData.append("name", this.$route.query.username);
    formData.append("email", this.$route.query.email);
    formData.append("userType", this.selectedUser);




    this.$API
        .post(this.$SignUp, formData, { withCredentials: true })
        .then((response) => {
            if (response.data.status === 400) {
                this.Loading = false;
                this.Message = response.data.message;
                this.Error = true;

            }
            if (response.status == 200) {

                alert('Please update your phone number on your profile');
               
                this.SetSession();
            } else {
                this.Loading = false;
                this.Error = true;
                this.Message = response.data.message;
            }
        })
        .catch((error) => {
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
        });
},
async SetSession(idToken, user, username) {
   
    console.log("username:" + username);
    try {
        const response = await this.$API.get(this.$InsertSession + "?idToken=" + this.$route.query.idToken);
        console.log("Response:", response);
        if (response.status === 200) {
            this.showProgress = false;
            const userData = response.data; // Access response.data
            console.log("User Data:", userData);
            const userType = userData.userType; // Correctly access userType
            console.log("User Type:", userType);
            await this.delay(5000);

            // Authenticate the user
            const isAuth = await this.UserAuth();
            if (isAuth) {
                // Redirect based on userType
                if (userType === '-') {
                    this.$router.push("Profile");
                } else if (userType === 'user') {
                    this.$router.push("Profile");
                } else {
                    this.$router.push("Dashboard");
                }
            } 
        } else {
            this.lblGoogle = "Google";
            console.error("Unexpected status code:", response.status);
        }
    } catch (error) {
        console.error("Error fetching user information:", error);
        this.lblGoogle = "Google";
        // Handle the error (e.g., show an error message)
    }
},
delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
},
    }

};
</script>

<style scoped>

</style>